export default __webpack_public_path__ + "media/images/icons/download-14a2b6c1a43ec6a8d3c572d142670e82.svg";